<template>
  <div class="box-members">
    <div class="box-family">
      <p style="text-align: left;font-size: 20px; font-weight: bold; line-height: 50px; margin-top: 20px;">Family</p>
      <img :src="memberUrl.mainImg" class="box-img" alt="">
    </div>
    <div class="box-single">
      <p style="text-align: left;font-size: 20px; font-weight: bold; line-height: 50px; margin-top: 20px; margin-left: 1vw">PhD. Students</p>
      <div v-for="(personalItem, index) in memberUrl.PhDList" :key="index" class="box-person-item">
        <div class="box-person-item-content">
          <div class="box-person-item-content-img">
            <img :src="personalItem.imgReqUrl" class="box-person-item-content-img-inner" alt="">
          </div>
          <div class="members-name" style="margin-left: 1vw;">
            <p>{{ personalItem.name }}</p>
          </div>
          <div style="text-align: left; margin-left: 1vw; word-break: break-all" >
            {{personalItem.bachelor}}<br>({{personalItem.year}})<br>
            {{personalItem.email}}
          </div>
        </div>
      </div>
      <div style="clear: both;"></div>
    </div>
    <div class="box-alumni">
      <p style="text-align: left;font-size: 20px; font-weight: bold; line-height: 50px; margin-top: 20px; margin-left: 1vw">Master Students</p>
      <div v-for="(personalItem, index) in memberUrl.masterList" :key="index" class="box-person-item">
        <div class="box-person-item-content">
          <div class="box-person-item-content-img">
            <img :src="personalItem.imgReqUrl" class="box-person-item-content-img-inner" alt="">
          </div>
          <div class="members-name" style="margin-left: 1vw;">
            <p>{{ personalItem.name }}</p>
          </div>
          <div style="text-align: left; margin-left: 1vw; word-break: break-all">
            {{personalItem.bachelor}}<br>({{personalItem.year}})<br>
            {{personalItem.email}}
          </div>
        </div>
      </div>
      <div style="clear: both;"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MembersPc',
  props: ['memberUrl'],
  data () {
    return {
      mainImg: require('../../assets/img/members/group.png'),
      PhDList: [
        {
          name: '韩旭',
          note: '',
          year: '2022',
          bachelor: 'PhD.',
          email: 'hanxu1996@nwafu.edu.cn',
          imgUrl: require('../../assets/img/members/博士_2022_韩旭_hanxu1996@nwafu.edu.cn.jpg')
        },
        {
          name: '徐仁乐',
          note: '',
          year: '2023',
          bachelor: 'PhD.',
          email: 'renlexu@nwafu.edu.cn',
          imgUrl: require('../../assets/img/members/博士_2023_徐仁乐_renlexu@nwafu.edu.cn.jpg')
        },
        {
          name: '刘美',
          note: '',
          year: '2022',
          bachelor: 'PhD.',
          email: 'liumei@nwafu.edu.cn',
          imgUrl: require('../../assets/img/members/博士_2022_刘美_liumei@nwafu.edu.cn.jpg')
        },
        {
          name: '张尚昆',
          note: '',
          year: '2022',
          bachelor: 'PhD.',
          email: 'kern@nwafu.edu.cn',
          imgUrl: require('../../assets/img/members/博士_2022_张尚昆_kern@nwafu.edu.cn.jpg')
        },
        {
          name: '王启凡',
          note: '',
          year: '2023',
          bachelor: 'PhD.',
          email: '1316606229@qq.com',
          imgUrl: require('../../assets/img/members/博士_2023_王启凡_1316606229@qq.com.jpg')
        }
      ],
      masterList: [
        {
          name: '谷世豪',
          note: '',
          year: '2021',
          bachelor: 'Master',
          email: 'gshao_907@nwafu.edu.cn',
          imgUrl: require('../../assets/img/members/硕士_2021_谷世豪_gshao_907@nwafu.edu.cn.jpg')
        },
        {
          name: '娄宇航',
          note: '',
          year: '2022',
          bachelor: 'Master',
          email: 'louyuhang@nwafu.edu.cn',
          imgUrl: require('../../assets/img/members/硕士_2022_娄宇航_louyuhang@nwafu.edu.cn.jpg')
        },
        {
          name: '孔玥',
          note: '',
          year: '2022',
          bachelor: 'Master',
          email: 'ky2022055668@nwafu.edu.cn',
          imgUrl: require('../../assets/img/members/硕士_2022_孔玥_ky2022055668@nwafu.edu.cn.jpg')
        },
        {
          name: '乔雨晴',
          note: '',
          year: '2023',
          bachelor: 'Master',
          email: 'yqdveoo@126.com',
          imgUrl: require('../../assets/img/members/硕士_2023_乔雨晴_yqdveoo@126.com.jpg')
        },
        {
          name: '吴佳盈',
          note: '',
          year: '2023',
          bachelor: 'Master',
          email: 'wujiaying1201@163.com',
          imgUrl: require('../../assets/img/members/硕士_2023_吴佳盈_wujiaying1201@163.com.jpg')
        }
      ]
    }
  }
}
</script>

<style scoped>
.box-members {
  width: 64vw;
  margin-left: 18vw;
  margin-top: 10px;
}
.box-family {
  width: 62vw;
  margin-left: 1vw;
}
.box-single {
  margin-top: 50px;
}
.box-alumni {
  margin-top: 50px;
}
.members-name {
  text-align: left;
  font-size: 18px;
  line-height: 30px;
  position: relative;
}
.members-name::after {
  content: "";
  width: 60px;
  height: 2px;
  bottom: 0;
  left: 0;
  position: absolute;
  background: #840163;
}
.box-img {
  max-width:100%;
  max-height:100%;
  vertical-align: middle;
}
.box-person-item {
  margin-top: 15px
}
.box-person-item-content {
  width: 16vw;
  min-height: 200px;
  float: left;
  margin-top: 15px
}
.box-person-item-content-img {
  width: 14vw;
  margin-left: 1vw;
  height: 14vw;
  overflow: hidden;
}
.box-person-item-content-img-inner {
  width: 14vw;
  vertical-align: middle;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/members/MembersPc.vue